import React from "react";
import {
  Box,
  Button,
  Typography,
  Modal,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

interface ChangeInventoryModalProps {
  open: boolean;
  onClose: () => void;
  getMoveService: any;
}

const ChangeInventoryModal: React.FC<ChangeInventoryModalProps> = ({
  open,
  onClose,
  getMoveService,
}) => {
  const renderInventory = () => {
    if (getMoveService?.move_type === "local") {
      try {
        // Parse the JSON string if it exists, otherwise use empty array
        const items = getMoveService?.items 
          ? JSON.parse(getMoveService.items) 
          : [];
        return (
          <List>
            {items.map((item: any, index: number) => (
              <ListItem key={index}>
                <ListItemText primary={`${item.name} - $${item.fee}`} />
              </ListItem>
            ))}
          </List>
        );
      } catch (error) {
        console.error("Error parsing items:", error);
        return <Typography color="error">Error loading inventory data</Typography>;
      }
    } else if (getMoveService?.move_type === "long_distance") {
      const inventory = getMoveService?.inventory?.inventory || [];
      const flattenedItems: any[] = [];

      inventory.forEach((room: any) => {
        room.images.forEach((image: any) => {
          image.items.forEach((item: any) => {
            flattenedItems.push({
              name: item.object_name,
              count: item.count,
              price: item.price,
            });
          });
        });
      });

      return (
        <List>
          {flattenedItems.map((item, index) => (
            <ListItem key={index}>
              <ListItemText
                primary={`${item.name} x${item.count} - $${item.price}`}
              />
            </ListItem>
          ))}
        </List>
      );
    } else {
      return <Typography>No inventory data available.</Typography>;
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="change-inventory-modal"
    >
      <Box
        sx={{
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          outline: "none",
        }}
      >
        <Typography id="change-inventory-modal" variant="h6" mb={2}>
          Change Inventory
        </Typography>

        {renderInventory()}

        <Box sx={{ mt: 2, textAlign: "right" }}>
          <Button variant="contained" onClick={onClose}>
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ChangeInventoryModal;